import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import icSearch from '../../../images/ic_search.png';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Loading from '../../../common/components/Loading/Loading';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import actions from '../../../redux/actions';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TableHeader from '../../../common/components/ItemTable/TableHeader';
import TableRow from '../../../common/components/ItemTable/TableRow';

const ViewMedicalServicesButton = (plan, getMedicalServices, selectPlan) => {
    const history = useHistory();

    return (
        <Ebutton classNameButton="ul-btn btn-medical-services"
                 onClick={()=>{
                     selectPlan(plan.name);
                     history.push('medicalServices');
                 }}
                 text=" Ver prestaciones"
        />
    );
};

const PlanList = (props) => {
    const {
        name,
        title,
        plans,
        switchOfUser,
        getPlansState,
        getPlans,
        getMedicalServices,
        selectPlan,
        cleanListConfig,
        showSidebar,
    } = props;
    const listData = [
        {title: 'NOMBRE', att: 'name', width: '80%'},
        // eslint-disable-next-line new-cap
        {title: '', component: (plan) => ViewMedicalServicesButton(plan, getMedicalServices, selectPlan), width: '20%'},
    ];
    const [search, setSearch] = useState('');
    const [items, setItems] = useState('');

    useEffect(() => {
        switchOfUser('Coberturas');
        getPlans();
        cleanListConfig('medicalServicesListConfig');
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        setItems(plans);
    }, [plans, getPlansState.success]);


    const handleSearch = () => {
        setItems(plans.filter((x) => x['name'].toString().toLowerCase().includes(search.toLowerCase())));
        setSearch('');
    };

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">
                <div className="ul-div-sect-header">
                    <div>
                        <p className="ul-p-title">{title.toUpperCase()}</p>
                        <hr id="id-hr"/>
                    </div>
                    <div>
                        <form onSubmit={(event)=>{
                            handleSearch();
                            event.preventDefault();
                        }} >
                            <div className="ul-div-serchCont">
                                <div className="ul-div-searchbar">
                                    <input
                                        placeholder="Buscar plan"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value.replace(/[^\w\s]/gi, ''))}
                                    />
                                    <button type='submit'><img src={icSearch} alt={'search'}/></button>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="ul-div-sect-table">
                    { getPlansState.success?
                        <table className="ul-div-table">
                            <TableHeader listData={listData} />
                            <tbody>
                            {
                                items?.length <= 0 ?
                                    <tr><td colSpan={100} ><CustomAlert text='planes' /></td></tr> :
                                    items?.map((item, index) =>
                                        <TableRow key={index} listData={listData} data={item} />,
                                    )
                            }
                            </tbody>
                        </table> :
                        getPlansState.loading?<Loading className="ul-div-sect-table" />:
                            <CustomAlert text={'planes' || String(getPlansState.error)} severity='error' />
                    }
                </div>

            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    name: localStorage.getItem('name'),
    title: state.home.title,
    plans: state.home.plans,
    getPlansState: state.home.getPlansState,
    showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
    switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
    getPlans: () => dispatch(actions.home.getPlansRequest()),
    getMedicalServices: (plans) => dispatch(actions.home.getMedicalServicesRequest(plans)),
    selectPlan: (plan) => dispatch(actions.home.selectPlan(plan)),
    cleanListConfig: (list) => dispatch( actions.home.cleanListConfig(list) ),
});

PlanList.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    getPlans: PropTypes.func,
    plans: PropTypes.object,
    getPlansState: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanList);

